import React from 'react'
import { useAuth } from '../../contexts/AuthContext'
import WeeklyScheduleGrid from './WeeklyScheduleGrid'
import MyScheduleView from './MyScheduleView'
import DayOffApprovalPanel from './DayOffApprovalPanel'
import BlockedDatesApprovalPanel from './BlockedDatesApprovalPanel'

const TEAM_ROLES = ['owner', 'office_staff', 'project_manager', 'crew_leader']

export default function SchedulePage() {
  const { profile } = useAuth()
  const role = profile?.role
  const canManage = TEAM_ROLES.includes(role)

  if (!profile) return null

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <div>
          <div style={styles.title}>SCHEDULE</div>
          <div style={styles.subtitle}>
            {canManage ? 'Weekly crew scheduling' : 'My week'}
          </div>
        </div>
      </div>

      {canManage && <DayOffApprovalPanel />}
      {canManage && <BlockedDatesApprovalPanel />}

      {canManage ? <WeeklyScheduleGrid /> : <MyScheduleView />}
    </div>
  )
}

const styles = {
  container: { maxWidth: '1200px', fontFamily: "'Barlow', sans-serif" },
  header: { display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: '24px' },
  title: { fontFamily: "'Barlow Condensed', sans-serif", fontSize: '28px', fontWeight: 700, letterSpacing: '3px', color: '#ffffff' },
  subtitle: { fontSize: '15px', color: 'rgba(255,255,255,0.35)', marginTop: '4px' },
}
